module.exports = __webpack_public_path__ + "static/media/Login.db4c45c8.png";